import { defineMessages, useIntl } from 'react-intl';

import CalmLogo from '@/components/CalmLogo';
import { useAnalytics } from '@/hooks/analytics';
import { useIsMobile } from '@/hooks/ui/useIsMobile';

import { Content, HeaderDiv, PurchaseButton } from './styles';

interface HeaderProps {
	bookBuyURL: string;
}

const Header = ({ bookBuyURL }: HeaderProps) => {
	const { logEvent } = useAnalytics();
	const { formatMessage } = useIntl();
	const [isMobile] = useIsMobile();

	const messages = defineMessages({
		purchase: {
			id: 'purchaseBook',
			defaultMessage: 'Purchase',
			description: 'Link to purchase book from amazon',
		},
	});

	const onClickBuy = () => {
		logEvent({
			eventName: 'Header : Buy : Clicked',
			eventProps: {
				url: bookBuyURL,
			},
		});
		window.open(bookBuyURL);
	};

	return (
		<HeaderDiv>
			<Content>
				<CalmLogo color="Gradient" height={isMobile ? 42 : 60} />
				<PurchaseButton aria-label="Purchase book from Amazon" onPress={onClickBuy}>
					{formatMessage(messages.purchase)}
				</PurchaseButton>
			</Content>
		</HeaderDiv>
	);
};
export default Header;
